
    /* eslint-disable */
    // 使用window.xxx避免被压缩删掉
    if (window.__wpm__importWpmLoader__garbage) {
      window.__wpm__importWpmLoader__garbage = "__wpm__importWpmLoader__wpmPackagesTagcopytrade_app/MainShare__wpm__importWpmLoader__wpmPackagesTag";
    }
    module.exports = window["__mfplugin__apg_app"].get("copytrade_app/MainShare")
    